var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketler = function SvgMarketler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#B8479A",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8c0 .275.232.5.515.5H7.72l1.855 3.795-.696 1.22c-.376.67.119 1.485.902 1.485h5.67a.51.51 0 0 0 .514-.5.51.51 0 0 0-.515-.5H9.781l.567-1h3.84c.386 0 .726-.205.901-.515l1.845-3.245c.191-.33-.056-.74-.448-.74H8.859l-.346-.715A.513.513 0 0 0 8.05 7.5H6.515A.51.51 0 0 0 6 8Zm3.781 7.5c-.566 0-1.025.45-1.025 1s.459 1 1.025 1c.567 0 1.031-.45 1.031-1s-.464-1-1.03-1Zm4.13 1c0-.55.458-1 1.025-1s1.03.45 1.03 1-.463 1-1.03 1-1.026-.45-1.026-1Z",
    fill: "#fff"
  })));
};
export default SvgMarketler;